export const MONITORING_QUEUE_ENTRY_MESSAGES = {
  NOT_FOUND: "No monitoring queue records were found",
};



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/constants/monitoringQueueEntryMessages.js